import api from '@/plugins/axios'

export interface SegmentoUiConfig {
  modulosHabilitados: string[]
  segmento: string
  plano: string
  usaPeso: boolean
  usaRaca: boolean
  usaProfissional: boolean
  usaValidade: boolean
  usaLote: boolean
  usaFabricante: boolean
  usaControlado: boolean
  usaGrade: boolean
  usaAgenda: boolean
  usaEntregas: boolean
  usaComandas: boolean
  usaFidelidade: boolean
  camposExtras: Record<string, any>
  mascaras: Record<string, string>
}

export interface OnboardingStatus {
  necessario: boolean
  motivo: string
}

class ConfigService {
  async getUiConfig(): Promise<SegmentoUiConfig> {
    const { data } = await api.get<SegmentoUiConfig>('/config/ui')
    return data
  }

  async getOnboardingStatus(): Promise<OnboardingStatus> {
    const { data } = await api.get<OnboardingStatus>('/config/onboarding-necessario')
    return data
  }
}

export default new ConfigService()
